<template>
    <div class="banner">
        <h3 class="banner__title">Собирай баллы РСВ и становись лучшим&nbsp;в&nbsp;рейтинге&nbsp;страны</h3>
        <!-- <h3 class="banner__title">Меняй баллы РСВ на то, что тебе по&nbsp;душе в Маркете РСВ</h3> -->
        <p class="banner__text">
            Совсем скоро ты сможешь обменять их на&nbsp;бонусы «Россия – страна возможностей» и наших партнеров
        </p>
        <!-- <p class="banner__text">Участвуй в социальных активностях страны и&nbsp;получай&nbsp;бонусы</p> -->
        <IconForBanner class="banner__svg-bg" />
        <!-- <a class="banner__btn-link" href="https://market.rsv.ru" target="_blank">
            Перейти в маркет
            <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14.5" cy="14" r="14" fill="white" fill-opacity="0.8" />
                <path
                    d="M8.5 14.0249H20.5M20.5 14.0249L16 9.76172M20.5 14.0249L16 18.288"
                    stroke="#4663AB"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </a> -->
    </div>
</template>

<script>
import IconForBanner from './svg/IconForBanner.vue';
export default {
    name: 'Banner',
    components: {
        IconForBanner,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.banner {
    width: 100%;
    height: mrem(435);
    position: relative;
    z-index: 1;
    padding: mrem(40) mrem(16);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    @include on-desktop {
        height: rem(435);
        padding: rem(40) rem(16);
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background: linear-gradient(325deg, rgba(54, 237, 200, 0.4) 0%, rgba(160, 54, 234, 0.4) 100%);
        opacity: 0.4;
        border-radius: mrem(16);
        z-index: -1;

        @include on-desktop {
            border-radius: rem(16);
        }
    }

    &__svg-bg {
        width: mrem(184);
        height: mrem(187);
        display: block;
        margin-bottom: mrem(16);

        @include on-desktop {
            width: rem(184);
            height: rem(187);
            margin-bottom: rem(16);
        }
    }

    &__title {
        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-size: mrem(16);
        line-height: mrem(26);
        color: #2a2626;
        margin: 0;
        margin-bottom: mrem(16);

        @include on-desktop {
            font-size: rem(18);
            line-height: rem(26);
            margin-bottom: rem(16);
        }
    }

    &__text {
        font-family: 'Montserrat', sans-serif;
        font-weight: 500;
        font-size: mrem(14);
        line-height: mrem(20);
        color: #2a2626;
        margin: 0;
        margin-bottom: mrem(16);

        @include on-desktop {
            font-size: rem(14);
            line-height: rem(24);
            margin-bottom: rem(16);
            width: 80%;
        }
    }

    &__btn-link {
        display: inline-flex;
        align-items: center;
        font-family: 'Montserrat', sans-serif;
        font-size: mrem(16);
        line-height: mrem(24);
        color: #4663ab;
        gap: mrem(6);
        font-weight: 600;

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(24);
            gap: rem(6);
        }

        &:hover {
            color: #69609f;

            svg {
                path {
                    stroke: #69609f;
                }
            }
        }

        svg {
            width: mrem(28);
            height: mrem(28);

            @include on-desktop {
                width: rem(28);
                height: rem(28);
            }
        }
    }
}
</style>
